import { Controller } from "@hotwired/stimulus";

// This controller toggles the visibility of dependent form sections based on
// the selected order type (on_site, pickup, delivery).
//
// Usage example:
// <div data-controller="order-type-selector">
//   <div class="flex gap-4 mb-6">
//     <label>
//       <input type="radio"
//              name="restaurant_order[order_type]"
//              value="on_site"
//              data-action=
//                "change->order-type-selector#toggle">
//       On-site
//     </label>
//     ... (other radios) ...
//   </div>
//
//   <div data-order-type-selector-target="dependent"
//        data-order-type-selector-show-when="on_site">
//      ... table selector ...
//   </div>
//   <div data-order-type-selector-target="dependent"
//        data-order-type-selector-show-when="pickup">
//      ... pickup contact fields ...
//   </div>
//   <div data-order-type-selector-target="dependent"
//        data-order-type-selector-show-when="delivery">
//      ... address fields ...
//   </div>
// </div>
export default class extends Controller {
  static targets = ["dependent"];

  connect() {
    const currentValue = this.currentValue();
    this.toggleVisibility(currentValue);
    this.updateRequiredAttributes(currentValue);
  }

  handleToggle(event) {
    const selectedValue = event.target.value;
    this.toggleVisibility(selectedValue);
    this.updateRequiredAttributes(selectedValue);
  }

  currentValue() {
    const checked = this.element.querySelector(
      "input[name='restaurant_order[order_type]']:checked"
    );
    return checked ? checked.value : null;
  }

  toggleVisibility(value) {
    this.dependentTargets.forEach((element) => {
      const showWhen = element.dataset.orderTypeSelectorShowWhen;
      if (!showWhen) return;

      const shouldShow = showWhen.split(",").includes(value);
      element.classList.toggle("hidden", !shouldShow);
    });
  }

  updateRequiredAttributes(selectedValue) {
    this.dependentTargets.forEach((section) => {
      const showWhen = section.dataset.orderTypeSelectorShowWhen;
      const isSectionActive = showWhen
        ? showWhen.split(",").includes(selectedValue)
        : false;

      const inputs = section.querySelectorAll(
        'input[data-conditionally-required="true"], select[data-conditionally-required="true"], textarea[data-conditionally-required="true"]'
      );

      inputs.forEach((input) => {
        input.required = isSectionActive;
      });
    });
  }
}
